export default __webpack_public_path__ + "static/jira-6de4100f14911fa6dca546500662f351.webp";